import { axios, AxiosResponse } from '~/modules'
import { EHealthProceduresTypes, IFetchImagingTest, IFetchImagingTestViews, IImagingTest } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

const fetchMaternalInfantImagingTest = async (params: IFetchImagingTest): Promise<IImagingTest> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/maternal-infant-imaging-tests/${pathParams.testId}`)
  const { data }: AxiosResponse<IImagingTest> = response
  return data
}

const fetchRadiologyImagingTest = async (params: IFetchImagingTest): Promise<IImagingTest> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/radiology-imaging-tests/${pathParams.testId}`)
  const { data }: AxiosResponse<IImagingTest> = response
  return data
}

export const getImagingTestFetchFunction = (
  view: IFetchImagingTestViews
): ((params: IFetchImagingTest) => Promise<IImagingTest>) => {
  switch (view) {
    case EHealthProceduresTypes.MATERNAL_INFANT_IMAGING_TEST:
      return fetchMaternalInfantImagingTest
    case EHealthProceduresTypes.RADIOLOGY_IMAGING_TEST:
      return fetchRadiologyImagingTest
    case EHealthProceduresTypes.EVALUATION_BREAST_IMAGING_TEST:
      return fetchRadiologyImagingTest
    case EHealthProceduresTypes.DIAGNOSIS:
      return fetchRadiologyImagingTest
    case EHealthProceduresTypes.DIAGNOSIS_BIOPSY:
      return fetchRadiologyImagingTest
  }
}
